import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image } from "../../../../../../base/multimedia/image/index.js";
import * as S from "./styled.js";
const resize = {
    shipImage: {
        width: 162,
        height: 135
    },
    logo: {
        width: 126,
        height: 81,
        suboperation: null
    },
    itineraryImage: {
        width: 240,
        height: 186
    }
};
const HeaderShipItinerary = ({ shipImage , logo , itineraryImage  })=>/*#__PURE__*/ _jsxs(S.CardProductHeader, {
        "data-testid": "HeaderShipItinerary",
        children: [
            /*#__PURE__*/ _jsx(Image, {
                className: "ship",
                ...shipImage,
                resize: resize.shipImage,
                isLazy: true
            }),
            /*#__PURE__*/ _jsx(Image, {
                className: "logo",
                ...logo,
                resize: resize.logo,
                isLazy: true
            }),
            /*#__PURE__*/ _jsx(Image, {
                className: "itinerary",
                ...itineraryImage,
                resize: resize.itineraryImage,
                isLazy: true
            })
        ]
    });
export default HeaderShipItinerary;

//# sourceMappingURL=index.js.map